export default {
  data() {
    return {
      customMO: null,
      isObserved: false,
    };
  },
  beforeDestroy() {
    this.unobserve();
  },
  methods: {
    observe(el = this.$el) {
      if (this.isObserved) {
        return;
      }

      el.onChildListModification = () => this.onSubtreeModification();

      this.isObserved = true;
      this.customMO = this.$window.createCustomMO();
      this.customMO.observe(el, { childList: true });
    },
    unobserve() {
      if (!this.isObserved) {
        return;
      }

      this.isObserved = false;
      this.customMO.disconnect();
    },
    onSubtreeModification() {},
  },
};
